import {Component} from "@angular/core";
import {PreparationResourceTypeSearchModel} from "../preparation-resource-type-search.model";
import {PreparationResourceTypeEntityModel} from "../preparation-resource-type-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-preparation-resource-type-search",
    templateUrl: "./preparation-resource-type-search-page.component.html",
    providers: [provideSearchModel(PreparationResourceTypeSearchModel), provideEntityModel(PreparationResourceTypeEntityModel)]
})
export class PreparationResourceTypeSearchPageComponent extends AbstractSearchPage {

}
